/// <reference path="../../../typings/tsd.d.ts" /> 
//module warsApp.models {
//    export enum ExpressionType {
//        Group,
//        Value,
//        Field,
//        Claim,
//        ProcessData
//    }
//    export abstract class Expression {
//        public parent:Expression
//        public comparsionOperator: ComparisonOperator;
//        abstract getType(): ExpressionType; 
//        public depth:number;
//    }
//    export class GroupExpression extends warsApp.models.Expression {
//       getType(): ExpressionType {
//           return ExpressionType.Group;
//       } 
//       public childExpressions:Expression[];
//    } 
//    export class TreeItemToConstantExpression extends warsApp.models.Expression {
//        getType(): ExpressionType { return ExpressionType.Value; }
//        public value: string;
//;
//    }
//    export class TreeItemToTreeItemExpression extends warsApp.models.BooleanExpression {
//        getType(): ExpressionType { return ExpressionType.Field; }
//        public valueText: string;
//        public valueFieldId: number;
//        public valueFieldName: string
//    }
//    export abstract class BooleanExpression extends warsApp.models.Expression {
//        public logicalOperator:LogicalOperator;
//        public fieldId: number;
//        public fieldName: string;
//        public fieldText: string;
//        public setComparsionOperator(operator: string) {
//            switch (operator) {
//                case "==":
//                    this.comparsionOperator = ComparisonOperator.Equals;
//                    break;
//                case "!=":
//                    this.comparsionOperator = ComparisonOperator.NotEquals;
//                break;
//                case ">":
//                    this.comparsionOperator = ComparisonOperator.GreaterThan;
//                break;
//                case "<":
//                    this.comparsionOperator = ComparisonOperator.LessThan;
//                break;
//                case ">=":
//                    this.comparsionOperator = ComparisonOperator.GreaterThanOrEqual;
//                break;
//                case "<=":
//                    this.comparsionOperator = ComparisonOperator.LessThanOrEqual;
//                break;
//                default:
//                    this.comparsionOperator = ComparisonOperator.Equals;
//            }
//        }
//    }
//}
//# sourceMappingURL=booleanExpression.js.map